import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router';
import { productListAPI } from './api-services/product.service';
import { kitchenListAPI } from './api-services/kitchen.service';
import { localStorageKeys } from '../global/constants';
import { getUrlParams, getUrlPath } from '../global/getUrl';
import { LoginDataContext } from './LoginDataProvider';
import { StoreHeaderDataContext } from './StoreHeaderDataProvider';
import { GlobalStateDataContext } from './GlobalStateDataProvider';
import jwt_decode from 'jwt-decode';
import { getDeliveryDayDate } from '../global/getDeliveryDayDate';
import { GenerateTimeSlotsForDelivery } from '../global/generateDeliveryTimeSlots';
import { distanceAndETA } from '../utils/distanceMileCalculate';

export const OnTheMenuDataContext = React.createContext();

const sortByZipcodeFirst = (array, value) => {
  let matchedObjects = [];
  let remainingObjects = [];

  array.forEach((obj) => {
    if (obj.Geolocation.zipcode === value) {
      matchedObjects.push(obj);
    } else {
      remainingObjects.push(obj);
    }
  });

  return matchedObjects.concat(remainingObjects);
};

// This is the main API call to get Data for products
const OnTheMenuDataProvider = ({ children }) => {
  const { kitchensByZipcodeResponse } = useContext(StoreHeaderDataContext) || {};
  const { onLoadInfoResponse } = useContext(GlobalStateDataContext);
  const { isLoggedIn, onLogout, customerInfoData } = useContext(LoginDataContext);
  const { ZIP_CODE, TOKEN, KITCHEN_NAMES, ZIPCODE_GEO_COORDINATES } = localStorageKeys;
  const navigate = useNavigate();
  const { storename: urlStoreName } = getUrlParams();

  const UpSaleProductUrlPath = () => getUrlPath().includes('/upsaleproducts');
  const NextDayPromotionMealPath = () => getUrlPath().includes('/nextdaypromotionmeal');
  const StoreMenuUrlPath = () => getUrlPath().includes('/onthemenu/storemenu');

  const [oneTimeMeal, setOneTimeMeal] = useState(false);
  const [howManyPerson, setHowManyPerson] = useState('');
  const [oneTimeMealPrice, setOneTimeMealPrice] = useState(0);

  const [Qty, setQty] = useState(1);
  const [selectedDate, setSelectedDate] = useState();
  const [cartItems, setCartItems] = useState({});
  const [payAsYouGoPayloadForCheckout, setPayAsYouGoPayloadForCheckout] = useState(null);

  const [promotionalOrderPayloadForCheckout, setPromotionalOrderPayloadForCheckout] =
    useState(null);

  const [remainingMealItemsCategoryWise, setRemainingMealItemsCategoryWise] = useState({
    showMealItemSnackBar: false,
    items: {},
  });
  const [selectedDeliverySlot, setSelectedDeliverySlot] = useState('');
  const [DeliveryPrice, setDeliveryPrice] = useState(0);
  const [DeliveryPriceWithoutAgreement, setDeliveryPriceWithoutAgreement] = useState(0);
  const [DeliveryFeeApplied, setDeliveryFeeApplied] = useState(null);

  const [nowTimeSlot, setNowTimeSlot] = useState('');
  const [subMenu, setSubMenu] = useState('');
  const [showDetail, setShowDetail] = useState(false);
  const [storeName, setStoreName] = useState(null);
  const [storeAccountType, setStoreAccountType] = useState(null);
  const [kitchenData, setkitchenData] = useState({
    errors: null,
    isLoading: false,
    data: null,
    success: null,
  });
  const [productsData, setProductsData] = useState({
    errors: null,
    isLoading: false,
    data: null,
  });

  const [restaurantList, setRestaurantList] = useState([]);
  const [promotionalKitchenList, setPromotionalKitchenList] = useState([]);
  const [homeChefList, sethomeChefList] = useState([]);
  const [cloudKitchenList, setCloudKitchenList] = useState([]);
  const [cateringList, setCateringList] = useState([]);
  const [celebrityChefList, setCelebrityChefList] = useState([]);
  const [cuisineList, setCuisineList] = useState([]);
  const [sortedKitchenData, setSortedKitchenData] = useState({
    kitchenName: null,
    kitchen_id: null,
    account_type: null,
    meal_offering: {
      complementry: null,
      kids_menu: null,
      main_dish: null,
    },
    operation_start_time: null,
    display_name: null,
    operation_end_time: null,
    opening_status: null,
    delivery_agreement_fees: null,
    address: null,
    deliveryPayAsYouGo_fee: null,
    deliverySubscription_fee: null,
    delivery_type_available: null,
    nearestKitchenNames: null,
    freePayAsYouGoDelivery: null,
    freePayAsYouGoDelivery_TimeGap: null,
    freeSubscriptionDelivery: null,
    freeSubscriptionDelivery_TimeGap: null,
    nearestKitchenNames: null,
    storeIsClosedForShortTime: null,
    agreedForFreeComboPromo: null,
    amountRequiredForComboPromo: null,
    subscriptionMenuAvailable: null,
    regularMenuAvailable: null,
    delivered_by: null,
    delivery_kitchen_fee: null,
    restrictedDeliveryDay: null,
    restrictedDeliveryStartTime: null,
    restrictedDeliveryEndTime: null,
    delivery_driver_shortage: null,
    status: null,
  });
  const [dedicatedDrivers, setDedicatedDrivers] = useState([]);
  const [activeButton, setActiveButton] = useState('delivery');
  const [selectedDeliveryOption, setSelectedDeliveryOption] = useState(
    activeButton === 'delivery' ? 'standard' : 'pickup'
  ); // New Added for new delivery types ( 'standard,prority etc )
  const [fullDeliverySlotObj, setFullDeliverySlotObj] = useState({});

  const [selectedStandardItem, setSelectedStandardItem] = useState({ name: 'none', size: '' }); // New state using in deliveryOptionNew
  const [selectedPickupItem, setSelectedPickupItem] = useState({ name: 'none', size: '' }); // New state using in deliveryOptionNew

  const [flagToDisplayFreeItems, setFlagToDisplayFreeItems] = useState(false);
  const [itemInCartOutOfDeliveryArea, setItemInCartOutOfDeliveryArea] = useState(false);
  const {
    delivery_agreement_fees,
    subscriptionMenuAvailable,
    kitchenName: kitchenNameName,
  } = sortedKitchenData;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const IsItemsInCart =
    cartItems?.mealItems?.length > 0 ||
    cartItems?.nonMealItems?.length > 0 ||
    cartItems?.promotionalItems?.length > 0;

  const NameKitchenInCart =
    cartItems?.nonMealItems?.[0]?.kitchen_name || cartItems?.mealItems?.[0]?.kitchen_name || '';

  const custInfoData = customerInfoData?.data?.data || [];
  const { meal_offering = {} } = sortedKitchenData;
  const getMealOffering = () => {
    const mealPlanMap = {
      'one person': 1,
      'two person': 2,
      'four person': 4,
    };
    let mealPlan = custInfoData?.meal_Package?.meal_plan || 'one person';

    if (oneTimeMeal && howManyPerson) {
      mealPlan = howManyPerson;
    }
    const mealPlanValue = mealPlanMap[mealPlan];
    const allowedMealPlanOffering = {};
    Object.keys(meal_offering).forEach((key) => {
      allowedMealPlanOffering[key] = mealPlanValue * meal_offering[key];
    });

    return allowedMealPlanOffering;
  };

  // GetKitchenInfoData method is created to get final delivery price on checkout for that store item in cart
  const GetKitchenInfoData = async () => {
    if (kitchenNameName !== NameKitchenInCart && IsItemsInCart) {
      const kitchenInfo = await kitchenListAPI([NameKitchenInCart]);
      const DataKitchenInfo = kitchenInfo?.data?.data[0] || [];

      // If you are adding anything to setSortedKitchenData pls add that code on  [ Pdp.jsx, StoreMenu.jsx, PromotionalKitchenMenu.js OntheMenuDataProvider.jsx ]
      const sortedKitchenDataForCheckout = {
        kitchenName: DataKitchenInfo?.kitchenName,
        kitchen_id: DataKitchenInfo?._id,
        account_type: DataKitchenInfo?.account_type,
        display_name: DataKitchenInfo?.display_name,
        display_image: DataKitchenInfo?.display_image,
        cuisine: DataKitchenInfo?.cuisine,
        meal_offering: DataKitchenInfo?.meal_offering,
        operation_start_time: DataKitchenInfo?.operation_start_time,
        operation_end_time: DataKitchenInfo?.operation_end_time,
        opening_status: DataKitchenInfo?.opening_status,
        delivery_agreement_fees: DataKitchenInfo?.delivery_agreement_fees,
        address: DataKitchenInfo?.Geolocation?.formattedAddress,
        deliveryPayAsYouGo_fee: DataKitchenInfo?.deliveryPayAsYouGo_fee,
        deliverySubscription_fee: DataKitchenInfo?.deliverySubscription_fee,
        delivery_type_available: DataKitchenInfo?.delivery_type_available,
        freePayAsYouGoDelivery: DataKitchenInfo?.freePayAsYouGoDelivery,
        freePayAsYouGoDelivery_TimeGap: DataKitchenInfo?.freePayAsYouGoDelivery_TimeGap,
        freeSubscriptionDelivery: DataKitchenInfo?.freeSubscriptionDelivery,
        freeSubscriptionDelivery_TimeGap: DataKitchenInfo?.freeSubscriptionDelivery_TimeGap,
        nearestKitchenNames: DataKitchenInfo?.nearestKitchenNames,
        storeIsClosedForShortTime: DataKitchenInfo?.storeIsClosedForShortTime,
        agreedForFreeComboPromo: DataKitchenInfo?.agreedForFreeComboPromo,
        amountRequiredForComboPromo: DataKitchenInfo?.amountRequiredForComboPromo,
        subscriptionMenuAvailable: DataKitchenInfo?.subscriptionMenuAvailable,
        regularMenuAvailable: DataKitchenInfo?.regularMenuAvailable,
        status: DataKitchenInfo?.status,
        delivered_by: DataKitchenInfo?.delivered_by,
        delivery_kitchen_fee: DataKitchenInfo?.delivery_kitchen_fee,
        restrictedDeliveryDay: DataKitchenInfo?.restrictedDeliveryDay,
        restrictedDeliveryStartTime: DataKitchenInfo?.restrictedDeliveryStartTime,
        restrictedDeliveryEndTime: DataKitchenInfo?.restrictedDeliveryEndTime,
        delivery_driver_shortage: DataKitchenInfo?.delivery_driver_shortage,
        pickup_order_promotion: DataKitchenInfo?.pickup_order_promotion,
        Geolocation: DataKitchenInfo?.Geolocation,
        package_plan: DataKitchenInfo?.package_plan,
        dedicated_drivers: DataKitchenInfo?.dedicated_drivers,
      };
      return sortedKitchenDataForCheckout;
    }

    return sortedKitchenData; // or {}
  };

  /* We are using 'totalItemsInCart' and 'subtotalInCart' varibales in (cart.jsx & CartMobile.jsx)
    we are calculating totalitems and subtotal in cartItemsobject 
    */
  let totalNonMealItems = 0;
  let subtotalInCart = 0;
  cartItems?.nonMealItems?.forEach((item) => {
    totalNonMealItems += item.selectedQuantity;
    let price = item.selectedQuantity * item.price;
    if (
      item?.promotion?.type === 'buy_one_get_one_free' &&
      item?.promotion?.active &&
      item.selectedQuantity > 1
    ) {
      price = (item.selectedQuantity - Math.floor(item.selectedQuantity / 2)) * item.price;
    } else if (
      item?.promotion?.type === 'buy_two_get_one_free' &&
      item?.promotion?.active &&
      item.selectedQuantity > 2
    ) {
      price = (item.selectedQuantity - Math.floor(item.selectedQuantity / 3)) * item.price;
    } else if (
      item?.promotion?.type === 'buy_one_get_half_price' &&
      item?.promotion?.active &&
      item.selectedQuantity > 1
    ) {
      price =
        (item.selectedQuantity -
          Math.floor(item.selectedQuantity / 2) +
          Math.floor(item.selectedQuantity / 2) / 2) *
        item.price;
    }
    subtotalInCart += price;
    if (item.extra_toppings) {
      item.extra_toppings.forEach((t) => {
        subtotalInCart += t.selectedQuantity * t.topping_price;
      });
    }
  });

  let UpSaleTotalAmount = 0;
  let totalUpSaleItemsInCart = 0;
  cartItems?.upsaleItems?.forEach((item) => {
    totalUpSaleItemsInCart += item.selectedQuantity;
    let price = item.selectedQuantity * item.price;
    UpSaleTotalAmount += price;
  });

  let totalMealItems = 0;
  cartItems?.mealItems?.forEach((item) => {
    totalMealItems += item.selectedQuantity;
  });

  let totalPromotionalItemsInCart = 0;
  cartItems?.promotionalItems?.forEach((item) => {
    totalPromotionalItemsInCart += item.selectedQuantity;
  });

  let oneTimeMeal_Price = 0;

  if (cartItems?.mealItems?.length > 0) {
    oneTimeMeal_Price = oneTimeMealPrice;
  }

  const totalItemsInCart = totalNonMealItems + totalMealItems + totalUpSaleItemsInCart;
  subtotalInCart = (subtotalInCart + UpSaleTotalAmount + oneTimeMeal_Price).toFixed(2);

  // Calculating deliver price with kitchen delivery_agreement_fees  percentage
  const calculatingWithDeliveryAgreementFee = (deliveryFee) => {
    let subtotalInCartOne = subtotalInCart;

    let deliveryPrice = deliveryFee;
    if (subtotalInCartOne && delivery_agreement_fees) {
      let applicableDeliveryAgreement = null;
      delivery_agreement_fees.sort((a, b) => a.minimumAmountSpend - b.minimumAmountSpend);
      for (let i = 0; i < delivery_agreement_fees.length; i++) {
        if (delivery_agreement_fees[i].minimumAmountSpend <= subtotalInCartOne) {
          applicableDeliveryAgreement = delivery_agreement_fees[i];
        }
      }

      const applicableDeliveryAgreementPercentage =
        applicableDeliveryAgreement?.percentageToPay_byKitchen || 0;
      deliveryPrice = deliveryFee - (deliveryFee * applicableDeliveryAgreementPercentage) / 100;
    }

    return deliveryPrice;
  };

  const RenderSubTotal = () => {
    if (cartItems?.nonMealItems?.length > 0 && totalMealItems !== 0) {
      return Number(subtotalInCart);
    } else if (cartItems?.nonMealItems?.length === 0 && totalMealItems !== 0) {
      return null;
    } else if (cartItems?.nonMealItems?.length > 0 && totalMealItems === 0) {
      return Number(subtotalInCart);
    }
  };

  const getOrderType = () => {
    const hasPayAsYouGoOrders = cartItems?.nonMealItems?.length > 0;
    const hasMealOrders = cartItems?.mealItems?.length > 0;

    if (hasMealOrders && hasPayAsYouGoOrders) {
      return 'joinedOrder';
    }
    if (hasMealOrders) {
      return 'mealOrder';
    }
    return 'payAsYouGoOrder';
  };

  const PickTimeSlotOne = () => {
    const Result = {
      Delivery_Slot: selectedDeliverySlot,
      TimeSlotType: selectedDeliveryOption,
      Delivery_Price: DeliveryPrice,
      Delivery_Price_Without_MerchAgreement: DeliveryPriceWithoutAgreement,
      Order_Type: getOrderType(),
      Delivery_fee_Applied: DeliveryFeeApplied,
    };
    // console.log('---PickTimeSlotOne', Result);
    return Result;
  };

  const CalculateDeliveryFees = (KitchenInfoData) => {
    const getGeoCoordinateLocal = () => [localStorage.getItem(ZIPCODE_GEO_COORDINATES)];
    const CustomerCoordinate = getGeoCoordinateLocal()[0]?.split(',')?.map(Number)?.reverse();
    const KitchenCoordinate = KitchenInfoData?.Geolocation?.coordinates?.reverse();
    let DistanceInMiles = 2.0;

    if (selectedDeliveryOption === 'standard' || selectedDeliveryOption === 'priority') {
      // console.log('------cartItems', cartItems);
      // console.log('---subtotalInCart', subtotalInCart);

      let delivery_fee = 1.99;
      if (CustomerCoordinate?.length > 0 && KitchenCoordinate?.length > 0) {
        const InMiles = distanceAndETA(CustomerCoordinate, KitchenCoordinate, {
          roadFactor: 1.0,
          avgSpeedMph: 22,
          trafficMultiplier: 1.25,
          fixedDelayMin: 2,
        });

        DistanceInMiles = Number(InMiles?.roadMiles);
      }

      const DeliveredBy = KitchenInfoData?.delivered_by;
      const MerchantPackage = KitchenInfoData?.package_plan; // We have merchant packages 'basic' or 'enterprise'
      const DeliveryByMerchant = KitchenInfoData?.delivery_kitchen_fee;

      if (DeliveredBy === 'kitchen') {
        return {
          TimeSlotType: selectedDeliveryOption,
          Delivery_Price: +calculatingWithDeliveryAgreementFee(DeliveryByMerchant)?.toFixed(2),
          Delivery_Price_Without_MerchAgreement: DeliveryByMerchant,
          Order_Type: getOrderType(),
          Delivery_fee_Applied: 'kitchen_fee_applied',
          DistanceInMiles: DistanceInMiles,
          baseFeeKey: 'delivery_kitchen_fee',
          dedicated_drivers: KitchenInfoData?.dedicated_drivers,
        };
      }

      if (DeliveredBy !== 'kitchen') {
        if (MerchantPackage) {
          const DeliveryByOtherDrivers_Standard =
            onLoadInfoResponse?.data?.data?.data?.operationFlags?.standard_delivery;
          const DeliveryByOtherDrivers_Priority =
            onLoadInfoResponse?.data?.data?.data?.operationFlags?.priority_delivery;
          const baseDistance = 2.5;
          const maxDistance = 10;
          const maxDeliveryFee = 9.99;

          // Decide which base fee key to use
          const baseFeeKey =
            MerchantPackage === 'basic' ? 'delivery_fee' : 'delivery_fee_enterprise_merchant_cust';

          // Map delivery options
          const deliveryConfigMap = {
            standard: DeliveryByOtherDrivers_Standard,
            priority: DeliveryByOtherDrivers_Priority,
          };

          const config = deliveryConfigMap[selectedDeliveryOption];
          // Safety check
          if (!config) {
            delivery_fee = null;
          } else {
            const baseFee = Number(config?.[baseFeeKey] || 0);
            const extraPerMile = Number(config?.delivery_fee_extra_miles || 0);

            if (DistanceInMiles > maxDistance) {
              delivery_fee = maxDeliveryFee;
            } else if (DistanceInMiles <= baseDistance) {
              delivery_fee = baseFee;
            } else {
              const extraMiles = Math.ceil(DistanceInMiles - baseDistance);
              delivery_fee = Number((baseFee + extraMiles * extraPerMile).toFixed(2));
            }
            return {
              Delivery_Price: +delivery_fee?.toFixed(2),
              Delivery_Price_Without_MerchAgreement: delivery_fee,
              Delivery_fee_Applied: 'regional_branch_fee_applied',
              Order_Type: getOrderType(),
              TimeSlotType: selectedDeliveryOption,
              DistanceInMiles: DistanceInMiles,
              baseFeeKey: baseFeeKey,
              dedicated_drivers: KitchenInfoData?.dedicated_drivers,
            };
          }
        }
      }
    }

    if (selectedDeliveryOption === 'pickup') {
      return {
        TimeSlotType: selectedDeliveryOption,
        Delivery_Price: 0,
        Delivery_Price_Without_MerchAgreement: 0,
        Order_Type: getOrderType(),
        Delivery_fee_Applied: null,
        DistanceInMiles: DistanceInMiles,
        baseFeeKey: null,
        dedicated_drivers: KitchenInfoData?.dedicated_drivers,
      };
    }
  };
  //  setDeliveryTimeSlotData    DELETE THIS  two old states
  // This is the MAIN method which will generate Delivery slots and set to state ( setSelectedDeliverySlot && setSelectedDate )
  // New way to getAndSet Delivery Time slots
  const getAndSetDeliveryTimeSlotOne = async () => {
    const KitchenInfoData = await GetKitchenInfoData();
    const triggerDeliverySlot = GenerateTimeSlotsForDelivery({
      KitchenInfoData,
      selectedDeliveryOption,
      onLoadInfoResponse,
    });

    const DeliveryFees = CalculateDeliveryFees(KitchenInfoData);

    setFullDeliverySlotObj(triggerDeliverySlot);
    setSelectedDeliverySlot(triggerDeliverySlot?.delivery_time_slot); // Setting delivery slot
    setSelectedDate(triggerDeliverySlot?.delivery_date); // Setting delivery date
    setDeliveryPrice(DeliveryFees?.Delivery_Price);
    setDeliveryPriceWithoutAgreement(DeliveryFees?.Delivery_Price_Without_MerchAgreement);
    setDeliveryFeeApplied(DeliveryFees?.Delivery_fee_Applied);
    setDedicatedDrivers(DeliveryFees?.dedicated_drivers);

    // console.log('----DeliveryFees', DeliveryFees);

    return triggerDeliverySlot;
  };

  const RedirectToCheckout = async ({ DeliveryType }) => {
    const KitchenOperationInfo = await GetKitchenInfoData();
    const DeliveryByKitchen = (await KitchenOperationInfo?.delivered_by) === 'kitchen'; // We have to make sure delivery is NOT by kitchen for to offer upSaleProducts should be FALSE

    if (
      DeliveryType === 'home delivery' &&
      DeliveryByKitchen === false &&
      UpSaleProductUrlPath() === false &&
      NextDayPromotionMealPath() === false
    ) {
      navigate('/upsaleproducts');
    } else if (
      (UpSaleProductUrlPath() === true ||
        (DeliveryType === 'pickup' && NextDayPromotionMealPath() === false)) &&
      ShowPromotionalKitchen() &&
      cartItems?.promotionalItems === undefined
    ) {
      navigate('/nextdaypromotionmeal');
    } else if (
      StoreMenuUrlPath() &&
      DeliveryByKitchen === true &&
      ShowPromotionalKitchen() &&
      cartItems?.promotionalItems === undefined
    ) {
      navigate('/nextdaypromotionmeal');
    } else {
      navigate('/checkoutorder');
    }
  };

  const RedirectToLogin = async () => navigate('/login');
  const RedirectToPaymentAddress = async () => navigate('/payment&address');
  const RedirectToCreditCardPage = () => navigate('/customeraccount/cards');
  const triggerLogout = async () => await onLogout();
  const RedirectToAddAddress = async () => navigate(`/customeraccount/deliveryaddress`);

  const NextDayMealPrice = onLoadInfoResponse?.data?.data?.data?.operationFlags?.nextday_meal_price;

  const onClickCheckout = async (redirect = true) => {
    setItemInCartOutOfDeliveryArea(false);
    const localStorageKitchens = () => localStorage.getItem(KITCHEN_NAMES);
    const custReasonStatus = customerInfoData?.data?.data?.user_Info?.reason_status;
    const custAddressLength = customerInfoData?.data?.data?.delivery_address;
    const KitchenName_InCartItems =
      cartItems?.mealItems?.[0]?.kitchen_name || cartItems?.nonMealItems?.[0]?.kitchen_name;

    if (!isLoggedIn) {
      return RedirectToLogin();
    }

    // This block will check if item in cart, its kitchen name is not in localstorage
    if (!localStorageKitchens().split(',').includes(KitchenName_InCartItems)) {
      const verbageText = `Sorry, restaurant can't deliver to your zipcode. Redirecting to OnTheMenu.`;
      setItemInCartOutOfDeliveryArea(true);
      return verbageText;
    }

    if (isLoggedIn && custReasonStatus === 'Inactive by admin') {
      triggerLogout();
      RedirectToLogin();
      return;
    }

    // We are redirecting to /payment&address when both card and address is missing
    if (
      isLoggedIn &&
      custAddressLength?.length === 0 &&
      custReasonStatus === 'Card adding pending'
    ) {
      RedirectToPaymentAddress();
      return;
    }

    if (isLoggedIn && custAddressLength?.length === 0) {
      RedirectToAddAddress();
      return;
    }

    if (
      isLoggedIn &&
      (custReasonStatus === 'Card decline' || custReasonStatus === 'Card adding pending')
    ) {
      RedirectToCreditCardPage();
      return;
    }

    const promoKtchenName = () =>
      kitchensByZipcodeResponse?.data?.promoKitchenNames?.[0] ||
      promotionalKitchenList?.[0]?.kitchenName;

    let promo_display_name = '';
    let nextDayMeal_Price = 0;
    let promo_kitchen_phone_no = null;
    let promo_kitchen_geolocation = null;

    if (promoKtchenName()) {
      if (promotionalKitchenList?.length === 0) {
        const kitchenPromo = await getKitchenList([promoKtchenName()]);
        nextDayMeal_Price = NextDayMealPrice;
        promo_display_name = kitchenPromo?.data?.[0]?.display_name;
        promo_kitchen_phone_no = kitchenPromo?.data?.[0]?.phone_no;
        promo_kitchen_geolocation = kitchenPromo?.data?.[0]?.Geolocation;
      } else {
        nextDayMeal_Price = NextDayMealPrice;
        promo_display_name = promotionalKitchenList?.[0]?.display_name;
        promo_kitchen_phone_no = promotionalKitchenList?.[0]?.phone_no;
        promo_kitchen_geolocation = promotionalKitchenList?.[0]?.Geolocation;
      }
    }

    const KitchenId_InCartItems =
      cartItems?.mealItems?.[0]?.kitchen_id || cartItems?.nonMealItems?.[0]?.kitchen_id;
    const kitchenName_PromoItems = cartItems?.promotionalItems?.[0]?.kitchen_name;
    const kitchenId_PromoItems = cartItems?.promotionalItems?.[0]?.kitchen_id;

    const CustDefaultAddress = () =>
      customerInfoData?.data?.data?.delivery_address?.find((item) => {
        return item.isDefault_address;
      });

    const hasTokens = localStorage.getItem(TOKEN);
    const decodedToken = () => jwt_decode(hasTokens);
    const { email } = decodedToken();

    const payAsYouGoOrderPayload = {};
    const mealOrderPayload = {};
    const promotionalOrderPayload = {};

    if (cartItems?.nonMealItems?.length > 0 || cartItems?.mealItems?.length > 0) {
      cartItems?.mealItems?.forEach((item) => {
        if (!mealOrderPayload.item_name) {
          mealOrderPayload.item_name = [];
        }

        const itemIndexInPayload = mealOrderPayload.item_name.findIndex(
          (obj) => obj.item === item.product_name
        );
        if (itemIndexInPayload > -1) {
          mealOrderPayload.item_name[itemIndexInPayload].qty =
            mealOrderPayload.item_name[itemIndexInPayload].qty + 1;
        }
        mealOrderPayload.item_name.push({
          item: item.product_name,
          qty: 1,
          mealItemPrice: item.price,
          product_category: item.product_category,
          menu: 'combo_menu',
        });
      });

      cartItems?.nonMealItems?.forEach((item) => {
        if (!payAsYouGoOrderPayload.item_names) {
          payAsYouGoOrderPayload.item_names = [];
        }

        const itemObj = {
          item: item.product_name,
          qty: item.selectedQuantity,
          menu: 'regular_menu',
          price: +item.price,
          extra_toppings: item?.extra_toppings?.map((t) => ({
            topping_name: t.topping_name,
            topping_qty: t.selectedQuantity,
          })),
        };
        if (item?.promotion?.active) {
          itemObj.promotion = item?.promotion?.type;
        }
        payAsYouGoOrderPayload.item_names.push(itemObj);
      });
      cartItems?.upsaleItems?.forEach((item) => {
        if (!payAsYouGoOrderPayload.upsale_item_names) {
          payAsYouGoOrderPayload.upsale_item_names = [];
        }

        const itemObj = {
          item: item.product_name,
          qty: item.selectedQuantity,
          price: +item.price,
          extra_toppings: item?.extra_toppings?.map((t) => ({
            topping_name: t.topping_name,
            topping_qty: t.selectedQuantity,
          })),
        };
        if (item?.promotion?.active) {
          itemObj.promotion = item?.promotion?.type;
        }
        payAsYouGoOrderPayload.upsale_item_names.push(itemObj);
      });

      payAsYouGoOrderPayload.delivery_date = selectedDate;
      payAsYouGoOrderPayload.delivery_time_slot = PickTimeSlotOne().Delivery_Slot;
      payAsYouGoOrderPayload.delivery_price = PickTimeSlotOne().Delivery_Price;
      payAsYouGoOrderPayload.delivery_fee_Applied = PickTimeSlotOne().Delivery_fee_Applied;
      payAsYouGoOrderPayload.order_type = PickTimeSlotOne().Order_Type;
      payAsYouGoOrderPayload.delivery_option_type = PickTimeSlotOne().TimeSlotType;
      payAsYouGoOrderPayload.delivery_price_without_merch_agreement =
        PickTimeSlotOne().Delivery_Price_Without_MerchAgreement;
      payAsYouGoOrderPayload.kitchen_name = KitchenName_InCartItems;
      payAsYouGoOrderPayload.kitchen_id = KitchenId_InCartItems;
      payAsYouGoOrderPayload.delivery_address =
        CustDefaultAddress()?.Geolocation?.formattedAddress ||
        'Something is wrong check with admin';
      payAsYouGoOrderPayload.customer_geolocation = CustDefaultAddress()?.Geolocation || null;
      payAsYouGoOrderPayload.delivery_type =
        activeButton === 'delivery' ? 'home delivery' : 'pickup';
      payAsYouGoOrderPayload.CustomerEmail = email;
      payAsYouGoOrderPayload.upsale_amount = UpSaleTotalAmount;
      payAsYouGoOrderPayload.pickup_free_item = selectedPickupItem;
      payAsYouGoOrderPayload.standard_delivery_free_item = selectedStandardItem;
      payAsYouGoOrderPayload.dedicated_drivers = dedicatedDrivers;
      payAsYouGoOrderPayload.meal_item_names = mealOrderPayload.item_name || [];

      if (cartItems?.mealItems?.length > 0) {
        payAsYouGoOrderPayload.oneTimeMeal_amount = oneTimeMeal_Price;
        payAsYouGoOrderPayload.oneTimeMeal_persons = howManyPerson;
      }
    }

    if (cartItems?.promotionalItems?.length > 0) {
      cartItems?.promotionalItems?.forEach((item) => {
        if (!promotionalOrderPayload.item_name) {
          promotionalOrderPayload.item_name = [];
        }

        const itemObj = {
          item: item.product_name,
          qty: item.selectedQuantity,
        };

        promotionalOrderPayload.item_name.push(itemObj);
      });

      promotionalOrderPayload.delivery_date = getDeliveryDayDate(selectedDate)?.fullDate;
      promotionalOrderPayload.delivery_time_slot = '01:00 PM - 04:00 PM';
      promotionalOrderPayload.kitchen_name = kitchenName_PromoItems;
      promotionalOrderPayload.kitchen_id = kitchenId_PromoItems;
      promotionalOrderPayload.kitchen_phone_no = promo_kitchen_phone_no;
      promotionalOrderPayload.kitchen_geolocation = promo_kitchen_geolocation;

      promotionalOrderPayload.delivery_address =
        CustDefaultAddress()?.Geolocation?.formattedAddress ||
        'Something is wrong check with admin';
      promotionalOrderPayload.customer_geolocation = CustDefaultAddress()?.Geolocation || null;
      promotionalOrderPayload.delivery_type = 'home delivery';
      promotionalOrderPayload.CustomerEmail = email;
      promotionalOrderPayload.display_name = promo_display_name; // We are just adding this key for display name on checkout
      promotionalOrderPayload.nextday_meal_price = nextDayMeal_Price * Qty;
    }

    // Payload for checkoutorder page
    setPayAsYouGoPayloadForCheckout(payAsYouGoOrderPayload);
    setPromotionalOrderPayloadForCheckout(promotionalOrderPayload);

    // setUpSaleItem

    const DeliveryType = activeButton === 'delivery' ? 'home delivery' : 'pickup';

    if (redirect) {
      RedirectToCheckout({ DeliveryType: DeliveryType });
    }
  };

  // {
  //     "kitchen_names": [
  //         "2525postmankitchen",
  //         "5555postmankitchen"
  //     ],
  //         "status": true,
  //         "serving_day" : "Monday",
  //         "email": "2222@testpostman.com"
  //         "device": "ios",
  // }

  // Parsig categories with products
  const productCategoryParsing = async (data = {}, payload = {}) => {
    try {
      const { kitchen_names = [] } = payload;

      const { MealItem_Categories = [], NonMealItem_Categories = [] } = data?.data || {};
      const kitchenProducts = {};

      kitchen_names.forEach((kitchenName) => {
        if (data?.data && [kitchenName] in data?.data) {
          kitchenProducts[kitchenName] = {};

          MealItem_Categories.forEach((cat) => {
            if (!kitchenProducts[kitchenName].MealItems) {
              kitchenProducts[kitchenName].MealItems = {};
            }
            if (data.data[kitchenName][cat]) {
              kitchenProducts[kitchenName].MealItems[cat] = data.data[kitchenName][cat]?.map(
                (item) => {
                  return {
                    ...item,
                    kitchen_id: data.data[kitchenName]?._id,
                    disabled:
                      !data?.data?.[kitchenName]?.meal_offering?.[cat] ||
                      !item.available_quantity ||
                      item.available_quantity -
                        (cartItems?.mealItems?.find(
                          (i) =>
                            i.product_name === item.product_name &&
                            i.product_category === item.product_category
                        )?.selectedQuantity || 0) ===
                        0,
                  };
                }
              );
            }
          });

          NonMealItem_Categories.forEach((cat) => {
            if (!kitchenProducts[kitchenName].NonMealItems) {
              kitchenProducts[kitchenName].NonMealItems = {};
            }
            if (data.data[kitchenName][cat]) {
              kitchenProducts[kitchenName].NonMealItems[cat] = data.data[kitchenName][cat]?.map(
                (item) => {
                  return {
                    ...item,
                    kitchen_id: data.data[kitchenName]?._id,
                    disabled:
                      !item.available_quantity ||
                      item.available_quantity -
                        (cartItems?.nonMealItems?.find(
                          (i) =>
                            i.product_name === item.product_name &&
                            i.product_category === item.product_category
                        )?.selectedQuantity || 0) ===
                        0,
                  };
                }
              );
            }
          });
        }
      });

      return kitchenProducts;
    } catch (error) {
      console.log('--------Catch block'.error);
    }
  };

  const getProductList = async (payload) => {
    try {
      if (payload?.isItForPromoProduct === undefined) {
        await setSortedKitchenData({});
      }

      setProductsData({ ...productsData, isLoading: true });
      const response = await productListAPI({ ...payload, status: true });

      if (response.hasError) {
        await setProductsData({
          ...productsData,
          data: null,
          isLoading: false,
          errors: response.message,
        });
      } else if (response.data.success) {
        await setProductsData({
          ...productsData,
          data: {
            ...response.data,
            categorizedProducts: await productCategoryParsing(response.data, payload),
          },
          isLoading: false,
          errors: null,
        });
      } else {
        await setProductsData({
          ...productsData,
          data: null,
          isLoading: false,
          errors: response.data.CustomMessage || response.data.errors.errorMessage,
        });
      }
    } catch (error) {
      console.log('------Get products API error Catch block', error);
      setProductsData({ ...productsData, data: null, isLoading: false, errors: error });
    }
  };

  const getGeoCoordinateLocal = () => [localStorage.getItem(ZIPCODE_GEO_COORDINATES)];

  const getKitchenList = async (payload) => {
    // You should sent payload in array example (  getKitchenList(['kitchenname 1', 'KitchenName 2']) )
    try {
      setkitchenData({ ...kitchenData, isLoading: true });
      const response = await kitchenListAPI(payload);

      if (response.hasError) {
        await setkitchenData({
          ...kitchenData,
          data: null,
          isLoading: false,
          errors: response.message,
          success: false,
        });
        return null;
      } else if (response?.data?.success) {
        setkitchenData({ ...kitchenData, data: response.data, isLoading: true });

        if (response?.data?.kitchen_count !== 0 || response?.data?.kitchen_count !== undefined) {
          const RestaurantList = [];
          const HomeChefList = [];
          const CloudKitchenList = [];
          const CateringList = [];
          const CuisineList = [];
          const CelebrityChefList = [];
          const PromotionalKitchenList = [];
          const CheckLocalStorageZipcode = localStorage.getItem(ZIP_CODE);

          response?.data?.data?.forEach((data) => {
            // Add Distance and ETA object in response
            const KitchenCoordinate = data.Geolocation?.coordinates?.reverse();
            const CustomerCoordinate = getGeoCoordinateLocal()[0]
              ?.split(',')
              ?.map(Number)
              ?.reverse();

            if (CustomerCoordinate?.length > 0 && KitchenCoordinate?.length > 0) {
              data.distanceAndETA = distanceAndETA(CustomerCoordinate, KitchenCoordinate, {
                roadFactor: 1.0,
                avgSpeedMph: 22,
                trafficMultiplier: 1.25,
                fixedDelayMin: 2,
              });
            }

            if (
              data.account_type === 'restaurant' &&
              (data.regularMenuAvailable === true || data.subscriptionMenuAvailable === true)
            ) {
              RestaurantList.push(data);
              CuisineList.push(data.cuisine);
            }

            if (
              data.account_type === 'home chef' &&
              (data.regularMenuAvailable === true || data.subscriptionMenuAvailable === true)
            ) {
              HomeChefList.push(data);
              CuisineList.push(data.cuisine);
            }
            if (data.account_type === 'cloud kitchen') {
              CloudKitchenList.push(data);
              CuisineList.push(data.cuisine);
            }
            if (data.account_type === 'catering') {
              CateringList.push(data);
              CuisineList.push(data.cuisine);
            }
            if (data.account_type === 'celebrity chef') {
              CelebrityChefList.push(data);
              CuisineList.push(data.cuisine);
            }
            if (data.account_type === 'promotional kitchen') {
              PromotionalKitchenList.push(data);
              CuisineList.push(data.cuisine);
            }
          });

          // console.log('---RestaurantList', RestaurantList)

          // const filteringByAvailableMenu = RestaurantList.filter((item) => {

          //     return (item.regularMenuAvailable === true || item.subscriptionMenuAvailable === true)
          // })

          // console.log('------New Filter list', filteringByAvailableMenu())

          setRestaurantList(
            sortByZipcodeFirst(RestaurantList, CheckLocalStorageZipcode).sort(
              (a, b) => a.visibility - b.visibility
            )
          );
          sethomeChefList(
            sortByZipcodeFirst(HomeChefList, CheckLocalStorageZipcode).sort(
              (a, b) => a.visibility - b.visibility
            )
          );
          setCloudKitchenList(CloudKitchenList.sort((a, b) => a.visibility - b.visibility));
          setCateringList(CateringList.sort((a, b) => a.visibility - b.visibility));
          setCelebrityChefList(CelebrityChefList.sort((a, b) => a.visibility - b.visibility));
          setPromotionalKitchenList(
            PromotionalKitchenList.sort((a, b) => a.visibility - b.visibility)
          );

          // Removing Duplication from array list
          let uniqueCuisineList = [...new Set(CuisineList)];
          setCuisineList(uniqueCuisineList);
          setkitchenData({ ...kitchenData, data: response.data, isLoading: false });
        }

        return response?.data;
      } else {
        setkitchenData({ ...kitchenData, data: null, isLoading: false, errors: response.data });
        return null;
      }
    } catch (error) {
      setkitchenData({ ...kitchenData, data: null, isLoading: false, errors: error });
      return null;
    }
  };

  const BranchPromoFlag =
    onLoadInfoResponse?.data?.data?.data?.operationFlags?.branchAgreedFreeComboPromoForPayAsYouGo;
  const BranchPromoFlagForSubscription =
    onLoadInfoResponse?.data?.data?.data?.operationFlags?.branchAgreedFreeComboPromoForSubscription;
  const permittedItemQty =
    onLoadInfoResponse?.data?.data?.data?.operationFlags?.permittedComboPromoItemQty;

  // We have this method in PromoProductCard.jsx
  const PromoSpendRequiredAmount = () => {
    if (sortedKitchenData?.agreedForFreeComboPromo) {
      return sortedKitchenData?.amountRequiredForComboPromo;
    }
    if (BranchPromoFlag) {
      return onLoadInfoResponse?.data?.data?.data?.operationFlags?.amountRequiredForComboPromo;
    }

    return 'No promotion available';
  };

  const HowMuchMoreToSpend = () => {
    const promoRequireSpendAmount = PromoSpendRequiredAmount();

    if (subtotalInCart > 0) {
      return (promoRequireSpendAmount - subtotalInCart).toFixed(2);
    }

    return promoRequireSpendAmount;
  };

  const AccountTypeSubscription = () =>
    customerInfoData?.data?.data?.user_Info?.account_type === 'Subscription';

  //const Promotional_Verbage = () => HowMuchMoreToSpend() <= 0 ? `Grab NextDay Combo just for $${NextDayMealPrice} + FREE Delivery` : `Get NextDay Combo just for $${NextDayMealPrice} + FREE Delivery when spend $${HowMuchMoreToSpend()} on regular menu`
  const Promotional_Verbage = () =>
    HowMuchMoreToSpend() <= 0 ? (
      <span>
        Grab NextDay Meal just for{' '}
        <span style={{ color: 'green', fontFamily: 'Inter Bold' }}>${NextDayMealPrice}</span> +{' '}
        <span style={{ color: 'green', fontFamily: 'Inter Bold' }}>FREE Delivery</span>
      </span>
    ) : (
      <span>
        NextDay Meal just for{' '}
        <span style={{ color: 'green', fontFamily: 'Inter Bold' }}>${NextDayMealPrice}</span> +{' '}
        <span style={{ color: 'green', fontFamily: 'Inter Bold' }}>FREE Delivery</span> when spend
        <span style={{ fontFamily: 'Inter Bold' }}> ${HowMuchMoreToSpend()}</span>
      </span>
    );

  //const Promotional_Verbage_SubscriptionCustomer = BranchPromoFlagForSubscription ? `Grab NextDay Meal for only $${NextDayMealPrice} — plus FREE Delivery when you add a combo to your order!` : Promotional_Verbage()
  const Promotional_Verbage_SubscriptionCustomer = BranchPromoFlagForSubscription ? (
    <span>
      NextDay Meal for only{' '}
      <span style={{ fontFamily: 'Inter Bold', color: 'green' }}> ${NextDayMealPrice}</span> +{' '}
      <span style={{ color: 'green', fontFamily: 'Inter Bold' }}>FREE Delivery</span> when you add a
      combo item to your order!
    </span>
  ) : (
    Promotional_Verbage()
  );

  const kitchenName = () =>
    cartItems?.nonMealItems?.[0]?.kitchen_name || cartItems?.mealItems?.[0]?.kitchen_name;
  const comparingKitchenName = () => kitchenName() === urlStoreName;

  const PromoVerbage = () => {
    if (totalPromotionalItemsInCart === 0) {
      if (
        AccountTypeSubscription() &&
        subscriptionMenuAvailable &&
        BranchPromoFlagForSubscription
      ) {
        if (cartItems?.mealItems?.length > 0) {
          return 'Don’t forget to add your NextDay Meal before you check out!';
        }
        return Promotional_Verbage_SubscriptionCustomer;
      } else {
        return Promotional_Verbage();
      }
    }

    if (totalPromotionalItemsInCart !== 0 && comparingKitchenName()) {
      return `${totalPromotionalItemsInCart} item added to cart`;
    } else {
      return `${
        AccountTypeSubscription() && subscriptionMenuAvailable
          ? Promotional_Verbage_SubscriptionCustomer
          : Promotional_Verbage()
      }`;
    }
  };

  // This method will display promotional free item component
  const ShowPromotionalKitchen = () => {
    if (AccountTypeSubscription() && BranchPromoFlagForSubscription) {
      return (
        (promotionalKitchenList.length > 0 ||
          kitchensByZipcodeResponse?.data?.promoKitchenNames?.length > 0) &&
        (sortedKitchenData?.agreedForFreeComboPromo || BranchPromoFlagForSubscription)
      );
    }

    if (
      AccountTypeSubscription() &&
      (sortedKitchenData?.agreedForFreeComboPromo || BranchPromoFlag)
    ) {
      return (
        (promotionalKitchenList.length > 0 ||
          kitchensByZipcodeResponse?.data?.promoKitchenNames?.length > 0) &&
        (sortedKitchenData?.agreedForFreeComboPromo || BranchPromoFlag)
      );
    }

    if (
      !AccountTypeSubscription() &&
      (sortedKitchenData?.agreedForFreeComboPromo || BranchPromoFlag)
    ) {
      return (
        (promotionalKitchenList.length > 0 ||
          kitchensByZipcodeResponse?.data?.promoKitchenNames?.length > 0) &&
        (sortedKitchenData?.agreedForFreeComboPromo || BranchPromoFlag)
      );
    }
  };

  return (
    <OnTheMenuDataContext.Provider
      value={{
        selectedDate,
        setSelectedDate,
        selectedDeliverySlot,
        setSelectedDeliverySlot,
        nowTimeSlot,
        setNowTimeSlot,
        subMenu,
        setSubMenu,
        showDetail,
        setShowDetail,
        getProductList,
        storeName,
        setStoreName,
        storeAccountType,
        setStoreAccountType,
        kitchenData,
        setkitchenData,
        getKitchenList,
        productsData,
        restaurantList,
        setRestaurantList,
        homeChefList,
        sethomeChefList,
        cloudKitchenList,
        setCloudKitchenList,
        cateringList,
        setCateringList,
        cuisineList,
        setCuisineList,
        celebrityChefList,
        setCelebrityChefList,
        sortedKitchenData,
        promotionalKitchenList,
        setPromotionalKitchenList,
        setSortedKitchenData,
        setProductsData,
        cartItems,
        setCartItems,
        totalItemsInCart,
        totalMealItems,
        subtotalInCart,
        activeButton,
        setActiveButton,
        remainingMealItemsCategoryWise,
        setRemainingMealItemsCategoryWise,
        onClickCheckout,
        calculatingWithDeliveryAgreementFee,
        ShowPromotionalKitchen,
        totalPromotionalItemsInCart,
        PromoSpendRequiredAmount,
        HowMuchMoreToSpend,
        PromoVerbage,
        flagToDisplayFreeItems,
        setFlagToDisplayFreeItems,
        itemInCartOutOfDeliveryArea,
        setItemInCartOutOfDeliveryArea,
        isDrawerOpen,
        setIsDrawerOpen,
        Qty,
        setQty,

        payAsYouGoPayloadForCheckout,
        setPayAsYouGoPayloadForCheckout,
        promotionalOrderPayloadForCheckout,
        setPromotionalOrderPayloadForCheckout,

        oneTimeMeal,
        setOneTimeMeal,
        howManyPerson,
        setHowManyPerson,
        oneTimeMealPrice,
        setOneTimeMealPrice,
        getMealOffering,
        UpSaleTotalAmount,
        oneTimeMeal_Price,
        selectedDeliveryOption,
        setSelectedDeliveryOption,
        selectedStandardItem,
        setSelectedStandardItem,
        selectedPickupItem,
        setSelectedPickupItem,

        getAndSetDeliveryTimeSlotOne,
        setFullDeliverySlotObj,
        fullDeliverySlotObj,
        PickTimeSlotOne,
        dedicatedDrivers,
        setDedicatedDrivers,
      }}
    >
      {children}
    </OnTheMenuDataContext.Provider>
  );
};

export default OnTheMenuDataProvider;
